const article = {
    id: 'raw-qc-bay-decision',
    title: 'Raw QC bay decision',
    summary: 'Raw QC must say if a bay finished its shoot types or needs a reshoot. That choice updates Live Shoot Reshoot and QC done for that bay.',
    publishedAt: '2026-09-24',
    tags: ['raw qc', 'reshoot'],
    sections: [
        {
            type: 'paragraph',
            text: 'Completing a SKU in Raw QC now asks for a bay decision when the last bay mapped every angle of the shoot types it did, and other shoot types are still unmapped. You choose whether that bay is done or whether it missed shots it was supposed to take.',
        },
        { type: 'heading', text: 'When to use' },
        {
            type: 'paragraph',
            text: 'The choice appears on Submit & Complete Sku, and only when a last shoot bay is known. It does not appear for a single comment, or when every shoot type is still incomplete.',
        },
        { type: 'heading', text: 'How to use' },
        {
            type: 'steps',
            items: [
                'In Raw QC, open the SKU and choose Submit & Complete Sku.',
                'Read the last shoot bay, the complete shoot types, and the pending shoot types (including any missing angles).',
                'Choose Shoot completed by bay if the remaining shoot types belong on another bay. No reshoot is sent.',
                'Choose Reshoot for bay if this bay missed shots it was supposed to take.',
                'Submit. The button stays disabled until one option is selected.',
            ],
        },
        { type: 'heading', text: 'How Live Shoot counts change' },
        {
            type: 'paragraph',
            text: 'The choice is applied only to the last bay that shot the SKU. Other bays on the same SKU are left as they are. Open Live Shoot and hover Reshoot or QC done for the same wording.',
        },
        {
            type: 'steps',
            items: [
                'Shoot completed by bay: the SKU is taken off Reshoot for that bay, if it was there, and added to QC done. Reshoot does not go up. No reshoot is sent back to the photographer.',
                'Reshoot for bay: the SKU is taken off Shot for that bay and added to Reshoot. QC done does not go up. This is the only way this decision increases Reshoot.',
                'QC done Details for that bay lists the SKU under finished shoot types when you chose Shoot completed by bay. Pending shoot types stay listed for the next bay.',
            ],
        },
        {
            type: 'note',
            text: 'Shot is the photographer marking shoot done. QC done is Raw QC finishing the SKU for that bay, including Shoot completed by bay. A normal full Raw QC complete still counts as QC done and does not ask for this choice.',
        },
    ],
};

export default article;
